import React, { useMemo } from 'react'
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SavingsIcon from '@mui/icons-material/Savings';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { formatPrice } from '../helper/functions';

export default function TopCards({ commonStats }) {
    const maxAPY = useMemo(() => {
        return Math.max(...commonStats.stakeApys)
    }, [commonStats.stakeApys]);

    

    return (
        <div className='row mt-4'>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <MonetizationOnIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>PST Price</h6>
                                <p>${commonStats.getTokenPrice ? formatPrice(commonStats.getTokenPrice) : 0}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <RecordVoiceOverIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>Total User</h6>
                                <p>{commonStats.totalStakers ? parseInt(commonStats.totalStakers) : 0}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <AccountBalanceIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>PST Amount</h6>
                                <p>{commonStats.totalStaked ? formatPrice(commonStats.totalStaked) : 0}</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-3'>
                <div className='box-card'>
                    <div className='box-card-body'>
                        <div className='d-flex'>
                            <div className='icon-box'>
                                <SavingsIcon sx={{ color: "#fff" }} fontSize="large" />
                            </div>
                            <div className='ms-3'>
                                <h6 className='mb-1'>Current APY</h6>
                                <p>UPTO {formatPrice(maxAPY / 100)}%</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
